// extracted by mini-css-extract-plugin
export var currentStep = "_id-2";
export var nodeCard = "_id-0";
export var pathHighlighted = "_id-1";